import { render } from "./PrescriptionDocumentsModal.vue?vue&type=template&id=2a1ec886&scoped=true"
import script from "./PrescriptionDocumentsModal.vue?vue&type=script&lang=js"
export * from "./PrescriptionDocumentsModal.vue?vue&type=script&lang=js"

import "./PrescriptionDocumentsModal.vue?vue&type=style&index=0&id=2a1ec886&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a1ec886"]])

export default __exports__